import { Dispatch, SetStateAction } from 'react';

import { SUBSCRIPTIONS_KEY } from '../../constants/websocket-events';
import { ActiveChannelsProps } from '../global-provider';

type contextType = {
  currency: string;
  isReconnection: boolean;
  setIsReconnection: Dispatch<SetStateAction<boolean>>;
  activeChannels: ActiveChannelsProps;
  messageHandlers: Map<any, any>;
  onUnsubscribeHandlers?: Map<any, any>;
  resetHeartbeatTimeout: () => void;
};

export type ParsedWebSocketMessage = Record<string, any> | null;

export const isSubscriptionKey = (data: any) => {
  const subscriptionKeys = Object.values(SUBSCRIPTIONS_KEY);
  if (data.id && typeof data.id === 'string') {
    return subscriptionKeys.some((key) => data.id.includes(key));
  }
};

export const handleNewMessage = (data: ParsedWebSocketMessage, context: contextType) => {
  if (!data) return;

  if (context.isReconnection) {
    context.setIsReconnection(false);
  }

  if (data.id === 'CUSTOM_HELLO_MESSAGE') {
    context.resetHeartbeatTimeout();
    return;
  }

  if (isSubscriptionKey(data)) {
    handleOpenChannelResponse(data, data?.id, context);
    return;
  }

  const handlerById = context.messageHandlers.get(data.id);

  if (handlerById) {
    handlerById(data);
    return;
  }

  if (data?.method === 'update') {
    handleUpdateMessage(data, context);
    return;
  }

  if (data?.method === 'subscription_ended') {
    const subscriptionKey = Object.keys(context.activeChannels).find(
      (key) =>
        !key.startsWith(SUBSCRIPTIONS_KEY.TOKEN_DATA) &&
        context.activeChannels[key] === data.params?.channel_id,
    );

    if (subscriptionKey) {
      const handler = context?.onUnsubscribeHandlers?.get(subscriptionKey);

      if (handler) {
        handler(data);
      }
    }
  }
};

const handleOpenChannelResponse = (data: any, key: string, context: contextType) => {
  if (data?.result) {
    const channelExists = Object.hasOwnProperty.call(context.activeChannels, key);
    const channelResultsExists = Object.values(context.activeChannels).includes(data.result);

    if (!channelExists && !channelResultsExists) {
      context.activeChannels[key] = data.result;
    }
  }
};

export const handleUpdateMessage = (data: any, context: contextType) => {
  const tokenDataKey = `${SUBSCRIPTIONS_KEY.TOKEN_DATA}_${context.currency}`;
  const isTokenDataCurrentCurrency =
    context.activeChannels[tokenDataKey] === data.params?.channel_id;

  if (isTokenDataCurrentCurrency) {
    const handler = context.messageHandlers.get(tokenDataKey);
    if (handler) {
      handler(data);
      return;
    }
  }

  const subscriptionKey = Object.keys(context.activeChannels).find(
    (key) =>
      !key.startsWith(SUBSCRIPTIONS_KEY.TOKEN_DATA) &&
      context.activeChannels[key] === data.params?.channel_id,
  );

  if (subscriptionKey) {
    const handler = context.messageHandlers.get(subscriptionKey);
    if (handler) {
      handler(data);
    }
  }
};
